// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"891":"18da7ce4d7c1096e","2216":"f7c66b1fded7b848","4023":"bdae8691c710cb70","4963":"bcf958b81bc4696a","8190":"3a6bd9ff8ba41be2"}[chunkId] + ".css";
};